"use client";

import { c as _c } from "react/compiler-runtime";
import { useCookie } from "@opensea/ui-kit/hooks";
import { SITE_URL } from "@opensea/utils";
import { CONNECTED_ACCOUNT_SERVER_HINT_COOKIE_NAME } from "@/providers/WalletProvider/constants";
export function useConnectedAccountServerHint() {
  const $ = _c(5);
  const [serverHint, setServerHint] = useCookie(CONNECTED_ACCOUNT_SERVER_HINT_COOKIE_NAME);
  let t0;
  if ($[0] !== setServerHint) {
    t0 = address => {
      const siteUrl = new URL(SITE_URL);
      setServerHint(address);
      setServerHint(address, {
        domain: siteUrl.hostname
      });
    };
    $[0] = setServerHint;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleSetServerHint = t0;
  let t1;
  if ($[2] !== handleSetServerHint || $[3] !== serverHint) {
    t1 = [serverHint, handleSetServerHint];
    $[2] = handleSetServerHint;
    $[3] = serverHint;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}